var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#1075DD",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 28.0002L29.9999 29.0943C29.4695 29.6744 28.7501 30.0002 28.0001 30.0002C27.2501 30.0002 26.5308 29.6744 26.0004 29.0943C25.4692 28.5154 24.75 28.1903 24.0002 28.1903C23.2504 28.1903 22.5311 28.5154 22 29.0943M13 30.0002H14.6745C15.1637 30.0002 15.4083 30.0002 15.6385 29.945C15.8426 29.896 16.0377 29.8152 16.2166 29.7055C16.4184 29.5818 16.5914 29.4089 16.9373 29.063L29.5 16.5002C30.3285 15.6718 30.3285 14.3287 29.5 13.5002C28.6716 12.6718 27.3285 12.6718 26.5 13.5002L13.9373 26.063C13.5914 26.4089 13.4184 26.5818 13.2947 26.7837C13.1851 26.9626 13.1043 27.1577 13.0553 27.3618C13 27.5919 13 27.8365 13 28.3257V30.0002Z",
    stroke: "#1F44DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.5913b6013cddb474369eae37131bed8e.svg";
export { ForwardRef as ReactComponent };